import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { HeaderPrintForm, Notification } from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { medicalExaminationService } from "api";

import {
  birthday2Age,
  convertIosStringToDate,
  convertIosStringToDate2,
  formatDateToString,
} from "helper/common";
import { FORMAT_TIME } from "types/enums";
import { getListDoiTuongAPI } from "redux/reducer/common";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import "./ToDieuTri.scss";

const catalogNDV = {
  xetNghiem: ["Huyết học", "Sinh hóa", "Vi sinh", "Nước tiểu"],
  CDHA: ["Chẩn đoán hình ảnh", "Khám bệnh"],
  dienTim: ["Điện tim"],
  PTTT: ["Phẫu thuật", "Thủ thuật", "Giường bệnh"],
};

function compareTime(a, b) {
  const timeA = a.gio;
  const timeB = b.gio;

  if (!a.ngay && !b.ngay) {
    // So sánh theo thuộc tính "date" nếu cả hai có giá trị null
    if (!a.time && !b.time) {
      return 0;
    } else if (!a.time) {
      return 1;
    } else if (!b.time) {
      return -1;
    }
  } else if (a.ngay === null) {
    return 1;
  } else if (b.ngay === null) {
    return -1;
  } else if (a.ngay > b.ngay) {
    return 1;
  } else if (a.ngay < b.ngay) {
    return -1;
  }

  // Chuyển đổi chuỗi "HH:mm" thành số (phút) để so sánh
  const minutesA =
    parseInt(timeA?.split(":")[0]) * 60 + parseInt(timeA?.split(":")[1]);
  const minutesB =
    parseInt(timeB?.split(":")[0]) * 60 + parseInt(timeB?.split(":")[1]);

  if (minutesA < minutesB) {
    return -1;
  } else if (minutesA > minutesB) {
    return 1;
  } else {
    return 0;
  }
}

const ToDieuTri = React.forwardRef((props: any, ref) => {
  const printRef = useRef<any>();
  const [dataPhieu, setDataPhieu] = useState<any>(null);

  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setDataPhieu: setDataPhieu,
    setThongTinBN: setThongTinBN,
  }));

  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [listToDieuTri, setListToDieuTri] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const getThuocs = (dts) => {
    let res = [];
    dts.map((it) => {
      res = [...res, ...it.thuocs];
    });
    return res;
  };
  const getDichVus = (dvs) => {
    let xnindex = 0;
    let cdhaindex = 0;
    let dientimindex = 0;
    let ptttindex = 0;
    let xn = [];
    let cdha = [];
    let dientim = [];
    let pttt = [];
    dvs.map((dt) => {
      xn = [
        ...xn,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.xetNghiem.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = xnindex;
            xnindex = xnindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      cdha = [
        ...cdha,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.CDHA.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = cdhaindex;
            cdhaindex = cdhaindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      dientim = [
        ...dientim,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.dienTim.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = dientimindex;
            dientimindex = dientimindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
      pttt = [
        ...pttt,
        ...dt.nhomChiDinhDtos
          .filter((et) => catalogNDV.PTTT.includes(et.tenNhomChiDinh))
          .map((ft) => {
            let idx = ptttindex;
            ptttindex = ptttindex + ft.chiDinhDtos.length;
            return { ...ft, index: idx };
          }),
      ];
    });
    return {
      xetNghiem: xn,
      cdha: cdha,
      dientim: dientim,
      pttt: pttt,
    };
  };
  useEffect(() => {}, [thongTinBN]);
  useEffect(() => {
    if (dataPhieu?.toDieuTriDtoList) {
      let tmp = [];
      dataPhieu?.toDieuTriDtoList.map((it) => {
        let toDieuTri = it.toDieuTri ? JSON.parse(it.toDieuTri) : null;
        if (toDieuTri?.table)
          Object.entries(toDieuTri?.table).forEach(([key, value]) => {
            tmp = [
              ...tmp,
              {
                ...(value as any),
                dsDichVu: getDichVus(it.phieuChiDinhDtos),
                dsThuoc: getThuocs(it.donThuocDtos),
              },
            ];
          });
      });
      setRows(tmp.sort((a, b) => compareTime(a, b)));
    } else {
      setRows([]);
    }
  }, [dataPhieu]);
  useEffect(() => {}, [rows]);
  const onPrint = async () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("print-content");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;
      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * headerHeight;
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };
  const cloneToPrint = () => {
    return printRef.current;
  };

  // useEffect(() => {}, [props.dmGiuong, props.dmGiuong]);
  return (
    <Row>
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
        destroyOnClose={true}
      >
        <div className="to-dieu-tri">
          <div ref={printRef}>
            <table className="print-content">
              <thead>
                <tr>
                  <td>
                    <Row style={{ margin: "24px 0 0 0" }}>
                      <Col span={12}>
                        <Row justify={"start"}>
                          <Typography.Text strong style={{ fontSize: "14px" }}>
                            BỘ Y TẾ
                          </Typography.Text>
                        </Row>
                        <Row>
                          <Typography.Text strong style={{ fontSize: "14px" }}>
                            BỆNH VIỆN CHUYEN KHOA MẮT ALINA
                          </Typography.Text>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={4}>
                        <Row justify={"start"}>
                          <Typography.Text style={{ fontSize: "14px" }}>
                            MS: 39/BV-01
                          </Typography.Text>
                        </Row>
                        <Row justify={"start"}>
                          <Typography.Text style={{ fontSize: "14px" }}>
                            Số vào viện:&nbsp;{thongTinBN?.maPhieuKham ?? ""}
                          </Typography.Text>
                        </Row>
                      </Col>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Title style={{ fontSize: "18pt" }}>
                        TỜ ĐIỀU TRỊ
                      </Typography.Title>
                      <Row justify={"center"}>
                        <Typography.Text>Số........</Typography.Text>
                      </Row>
                    </Row>
                    {/* <Row justify={"start"} style={{ marginBottom: "12px" }}> */}
                    <Row>
                      <Col span={15}>
                        <Typography.Text>{`Họ tên người bệnh:   ${
                          thongTinBN?.tenBenhNhan ?? ""
                        }`}</Typography.Text>
                      </Col>
                      <Col span={5}>
                        <Typography.Text>{`Tuổi: ${
                          thongTinBN?.ngaySinh
                            ? birthday2Age(thongTinBN?.ngaySinh)
                            : "--"
                        }`}</Typography.Text>
                      </Col>
                      <Col span={4}>
                        <Typography.Text>{`${
                          gioiTinhOptions.find(
                            (it) => it.value === thongTinBN?.gioiTinh ?? null
                          )?.label || ""
                        }`}</Typography.Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={15}>
                        <Typography.Text>{`Khoa mắt tổng hợp:   ${
                          thongTinBN?.khoaDieuTri ?? ""
                        }`}</Typography.Text>
                      </Col>
                      <Col span={5}>
                        <Typography.Text>{`Buồng:   ${
                          props.dmBuong?.find(
                            (it) => it.id === (thongTinBN?.idBuongSo ?? null)
                          )?.tenPhong ?? ""
                        }`}</Typography.Text>
                      </Col>
                      <Col span={4}>
                        <Typography.Text>{`Giường:   ${
                          props.dmGiuong?.find(
                            (it) => it.id === (thongTinBN?.idGiuongSo ?? null)
                          )?.soGiuong ?? ""
                        }`}</Typography.Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={4}>
                        <Typography.Text style={{ fontSize: "13pt" }}>
                          Chẩn đoán:&nbsp;{" "}
                        </Typography.Text>
                      </Col>
                      <Col flex={"auto"}>
                        {/* {thongTinBN?.chiTietKetLuans?.length > 0
                          ? thongTinBN?.chiTietKetLuans
                              ?.reverse()
                              .map((item) => (
                                <Row className="nameChanDoan">
                                  {item.maIcd} - {item.tenIcd}
                                </Row>
                              ))
                          : "" || (
                              <Row className="nameChanDoan">
                                {thongTinBN?.icdChanDoan} -{" "}
                                {thongTinBN?.chanDoan}
                              </Row>
                            )} */}
                        <Row className="nameChanDoan">
                          {dataPhieu?.icdChanDoan
                            ? dataPhieu?.icdChanDoan + " - "
                            : ""}
                          {dataPhieu?.chanDoan}
                        </Row>
                      </Col>
                    </Row>
                    {/* </Row> */}
                  </td>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td></td>
                </tr>
                <tr>
                  <div className="my-table-custom">
                    <table style={{ borderSpacing: "0px" }}>
                      <thead style={{ display: "table-header-group" }}>
                        <tr style={{ visibility: "collapse", height: "20px" }}>
                          <td></td>
                        </tr>
                        <tr>
                          <th style={{ width: "16%" }}>
                            <Typography.Text strong>NGÀY/GIỜ</Typography.Text>
                          </th>
                          <th style={{ width: "42%" }}>
                            <Typography.Text strong>
                              DIỄN BIẾN BỆNH
                            </Typography.Text>
                          </th>
                          <th style={{ width: "42%" }}>
                            <Typography.Text strong>Y LỆNH</Typography.Text>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((it, idx) => {
                          return (
                            <tr
                              style={{
                                // pageBreakInside: "avoid",
                                pageBreakAfter: "auto",
                              }}
                            >
                              <td
                                style={{
                                  verticalAlign: "top",
                                  paddingLeft: "8px",
                                }}
                              >
                                <Typography.Text>{`${
                                  it?.ngay
                                    ? dayjs(it?.ngay, "DD/MM/YYYY")?.format(
                                        "DD/MM/YYYY"
                                      )
                                    : ""
                                } - ${it.gio ?? ""}`}</Typography.Text>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  paddingLeft: "8px",
                                }}
                              >
                                <Typography.Text
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  <div>{it?.dienBienBenh ?? ""}</div>
                                </Typography.Text>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  paddingLeft: "8px",
                                }}
                              >
                                <Typography.Text
                                  style={{ whiteSpace: "pre-line" }}
                                >{`${it?.yLenh ?? ""}`}</Typography.Text>
                                {it.dsThuoc.map((dt) => {
                                  return (
                                    <Row>
                                      <Typography.Text>{`+ ${dt.tenThuoc} x ${
                                        dt.soLuong
                                      } ${dt.donVi} ${
                                        dt.lieuDung ?? ""
                                      }`}</Typography.Text>
                                    </Row>
                                  );
                                })}
                                {it.dsDichVu.xetNghiem.length +
                                  it.dsDichVu.cdha.length +
                                  it.dsDichVu.dientim.length +
                                  it.dsDichVu.pttt.length >
                                0 ? (
                                  <Row>
                                    <Typography.Text strong>
                                      CLS:
                                    </Typography.Text>
                                  </Row>
                                ) : null}
                                {it.dsDichVu.xetNghiem.length > 0 ? (
                                  <Row>
                                    <Row>
                                      <Typography.Text>{`XN:`}</Typography.Text>
                                    </Row>
                                    {it.dsDichVu.xetNghiem.map((dt) => {
                                      return dt.chiDinhDtos.map((x) => {
                                        return (
                                          <Row>
                                            <Typography.Text>{`+ ${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                                          </Row>
                                        );
                                      });
                                    })}
                                  </Row>
                                ) : null}
                                {it.dsDichVu.cdha.length > 0 ? (
                                  <Row>
                                    <Row>
                                      <Typography.Text>{`CĐHA:`}</Typography.Text>
                                    </Row>
                                    {it.dsDichVu.cdha.map((dt) => {
                                      return dt.chiDinhDtos.map((x) => {
                                        return (
                                          <Row>
                                            <Typography.Text>{`+ ${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                                          </Row>
                                        );
                                      });
                                    })}
                                  </Row>
                                ) : null}
                                {it.dsDichVu.dientim.length > 0 ? (
                                  <Row>
                                    <Row>
                                      <Typography.Text>{`Điện tim:`}</Typography.Text>
                                    </Row>
                                    {it.dsDichVu.dientim.map((dt) => {
                                      return dt.chiDinhDtos.map((x) => {
                                        return (
                                          <Row>
                                            <Typography.Text>{`+ ${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                                          </Row>
                                        );
                                      });
                                    })}
                                  </Row>
                                ) : null}
                                {it.dsDichVu.pttt.length > 0 ? (
                                  <Row>
                                    <Row>
                                      <Typography.Text>{`+ PT/TT:`}</Typography.Text>
                                    </Row>
                                    {it.dsDichVu.pttt.map((dt) => {
                                      return dt.chiDinhDtos.map((x) => {
                                        return (
                                          <Row>
                                            <Typography.Text>{`${x.tenChiDinh} (${x.soLuong} lần)`}</Typography.Text>
                                          </Row>
                                        );
                                      });
                                    })}
                                  </Row>
                                ) : null}
                                <div style={{ height: "120px" }}></div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr style={{ visibility: "collapse" }}>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>

                    {/* <Row justify={'space-between'} style={{marginTop: "12px", marginRight: "24px"}}>
                      <Col></Col>
                      <Col>
                        <Row justify={'center'}>
                          <Typography.Text>{`Ngày ${dayjs().day()} tháng ${dayjs().month()} năm ${dayjs().year()}`}</Typography.Text>
                        </Row>
                        <Row justify={'center'}>
                          <Typography.Title level={5} style={{marginTop: "0"}}>BÁC SĨ KHÁM BỆNH</Typography.Title>
                        </Row>
                        <Row justify={'center'} style={{marginTop: "36px"}}>
                          <Typography.Text strong>{localStorage.getItem("fullName") ?? ""}</Typography.Text>
                        </Row>
                      </Col>
                    </Row> */}
                  </div>
                </tr>
              </tbody>
              <tfoot>
                <tr style={{ height: "1cm" }}>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <Row
            justify={"end"}
            className="footer"
            style={{ gap: "4px", marginTop: "8px" }}
          >
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    In
                  </Button>
                );
              }}
              content={() => cloneToPrint()}
              onAfterPrint={closeModal}
              bodyClass="to-dieu-tri"
            />
          </Row>
        </div>
      </Modal>
    </Row>
  );
});
export default ToDieuTri;
